exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#thongsophutai #cboSocongto {\n  width: 130px;\n  display: inline-block; }\n\n#thongsophutai .btn {\n  margin-top: -5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/views/giam-sat/thong-so-phu-tai/chi-tiet/thongsophutai-chitiet.component.scss
// module id = ../../../../../src/app/views/giam-sat/thong-so-phu-tai/chi-tiet/thongsophutai-chitiet.component.scss
// module chunks = main